<template>
  <div id="app" data-v-app="">
    <!-- 阶段1：加载圆圈 -->
    <PageLoader
      v-if="loadingPhase === 'initial'"
      :show="true"
      text="正在连接..."
    />

    <!-- 阶段2：骨架屏 -->
    <SkeletonChat v-else-if="loadingPhase === 'skeleton'" />

    <!-- 阶段3：真实内容 -->
    <transition name="fade">
      <div v-if="loadingPhase === 'ready'">
        <!-- 错误页面：客服不存在 -->
        <div v-if="agentNotFound" class="error-container">
          <div class="error-icon">⚠️</div>
          <div class="error-title">链接无效</div>
          <div class="error-message">该客服账号不存在或链接已失效</div>
          <div class="error-hint">请检查链接是否正确，或联系管理员获取有效链接</div>
        </div>

        <!-- 正常聊天界面 -->
        <div v-else class="Nai-ILtRYL-1e-Long">
      <div class="" style="display: none;"><div class=""></div></div>
      <div class="Nai-CiHtqV7VV-Long" :style="{ backgroundImage: `url(${topBgImg})` }">
        <div>
          <img class="back-icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAP1JREFUWEft1jEKwjAUxvH3egZnB8EDlFzCwTM4ixdwc9UTiCfwGs4O39IjODsIrpWUQgtFhLzkvdilXRv6/yWBR5lGfnjkPk0A8xNwzs0BPKRXawooy3JfFMWBiNYAbhKEGaCLn7rom4gWAJ4hhAngK/4hog2AayjevlcDNHE1QBtXASziyQCreBLAMh4NsI5HAXLExYBccTHAObf13p+Zmb33npl3AC6SQRNaIx5EuRBiQLuTHIgoQA5ENMAakQSwRCQDrBAqgAVCDdAiTAA/EC9mXv7tl6yfdt2cONZ1vaqq6h6aguJRLPnQADGT7Lxfb3YFMcjh2gkw+gk0jObMIVi+pe4AAAAASUVORK5CYII=">
          <div class="Nai-gZ8pzdoJo-Long">
            <div class="Nai-tEnVfMX2v-Long">
              <div>商品交易专员-白菜</div>
              <img src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20fill='none'%20version='1.1'%20width='32'%20height='16'%20viewBox='0%200%2032%2016'%3e%3cdefs%3e%3clinearGradient%20x1='0'%20y1='0.5'%20x2='1'%20y2='0.5'%20id='master_svg0_1_6585'%3e%3cstop%20offset='0%25'%20stop-color='%23FFF7EA'%20stop-opacity='1'/%3e%3cstop%20offset='100%25'%20stop-color='%23FFECCA'%20stop-opacity='1'/%3e%3c/linearGradient%3e%3c/defs%3e%3cg%3e%3crect%20x='0'%20y='0'%20width='32'%20height='16'%20rx='4'%20fill='url(%23master_svg0_1_6585)'%20fill-opacity='1'/%3e%3cg%3e%3cpath%20d='M6.41688,5.96106L7.32644,5.96106L7.32644,13.9476L6.41688,13.9476L6.41688,5.96106ZM6.87025,5.96106L13.54319,5.96106L13.54319,9.03456L6.87025,9.03456L6.87025,8.246690000000001L12.6475,8.246690000000001L12.6475,6.74894L6.87025,6.74894L6.87025,5.96106ZM6.917120000000001,10.18412L13.9825,10.18412L13.9825,13.8923L13.06075,13.8923L13.06075,10.99356L6.917120000000001,10.99356L6.917120000000001,10.18412ZM6.95444,12.6064L13.3585,12.6064L13.3585,13.4086L6.95444,13.4086L6.95444,12.6064ZM4.89475,4.07444L15.0985,4.07444L15.0985,6.20988L14.1535,6.20988L14.1535,4.9232499999999995L5.80244,4.9232499999999995L5.80244,6.20988L4.89475,6.20988L4.89475,4.07444ZM9.372620000000001,3.05725L10.2775,2.85888Q10.46012,3.18812,10.62119,3.58956Q10.782250000000001,3.99081,10.84487,4.2741299999999995L9.9025,4.501189999999999Q9.837060000000001,4.22256,9.687809999999999,3.81063Q9.53856,3.3985,9.372620000000001,3.05725ZM16.816200000000002,4.99788L27.2279,4.99788L27.2279,5.87012L16.816200000000002,5.87012L16.816200000000002,4.99788ZM20.5714,7.79481L25.3667,7.79481L25.3667,8.6695L20.5714,8.6695L20.5714,7.79481ZM25.1206,7.79481L26.0588,7.79481Q26.0588,7.79481,26.0528,7.87563Q26.0468,7.95625,26.0444,8.05713Q26.0421,8.15781,26.0254,8.22925Q25.9075,9.9325,25.7755,10.98644Q25.6435,12.0404,25.4768,12.6064Q25.3101,13.1725,25.0681,13.4117Q24.8631,13.6381,24.6213,13.7211Q24.3796,13.8042,24.0332,13.8302Q23.7124,13.8563,23.1631,13.8417Q22.6139,13.8271,22.0066,13.7931Q21.9946,13.5921,21.9096,13.3416Q21.8249,13.0911,21.6852,12.9115Q22.3337,12.9668,22.9037,12.9826Q23.4738,12.9981,23.7179,12.9981Q23.9172,12.9981,24.0479,12.9719Q24.1786,12.9454,24.2886,12.8567Q24.4759,12.6861,24.6248,12.1473Q24.7739,11.6082,24.8965,10.58444Q25.0191,9.5605,25.1206,7.94894L25.1206,7.79481ZM20.1074,5.51631L21.0972,5.51631Q21.0492,6.457,20.9519,7.42938Q20.8546,8.40156,20.6335,9.34019Q20.4126,10.27881,19.9996,11.1381Q19.5867,11.9974,18.909599999999998,12.7255Q18.2327,13.4536,17.217399999999998,13.9878Q17.1132,13.8154,16.921599999999998,13.6099Q16.7299,13.4046,16.5529,13.2724Q17.5188,12.7904,18.151,12.1225Q18.7832,11.4544,19.1622,10.666Q19.5411,9.87756,19.729,9.01075Q19.9169,8.14375,19.9904,7.25669Q20.0641,6.36944,20.1074,5.51631ZM21.2851,3.184L22.1494,2.8434999999999997Q22.3967,3.26875,22.6463,3.76713Q22.8961,4.2653099999999995,23.0254,4.627940000000001L22.1112,5.02262Q21.9959,4.65531,21.7559,4.13706Q21.5159,3.61862,21.2851,3.184Z'%20fill='%23A57A43'%20fill-opacity='1'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e" style="width: 28px; height: 13px;">
            </div>
            <div class="Nai--X4XzKRYG-Long">
              <div class="Nai-ii0ZKQ-ce-Long"></div>
              <div class="Nai-YBu77Ftyx-Long">在线</div>
              <div class="Nai-menJcQ9ZK-Long">(9:30-00:30)</div>
            </div>
          </div>
        </div>
        <div class="header-right-icons">
          <img src="data:image/png;base64,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" class="header-icon" draggable="false" @click="showSidePanel = true">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAchJREFUWEftmEFOwlAQhue1IUbiAk3EkHAClAQYb+BO9ASu9AZGvQVGb+DKG4A7vcEAC+2alcEY0YUBu+CNeaZNkIAlmZq+hHb7Ou3X/3/TmTcKLL+U5XyQAkodWh4FS6XSWjab3TOKDYfDe8/zPqXqmfhYFKzVaqiUagHAVgD1wsz1drtNUshYABHxEQC2p2CeiGgncUBELADA8yyQ0WhU8DyvL4EUK1gsFlfz+fy7UmplEoSZ/cFgkOv1el+JApqXI2IDAM6mQBpEdCGBiy1JAMBFxFMAOAIABoBbIroGgLEtgFKOufHiPfhvZMGDU0CpwrEqWKlUcgao2+1+SMHC+FgAq9XqpuM4N8y8//NrUOpOa33c6XRepaCxACJiEwDqUzAtIjpIHLBcLq9nMpk3pdSvj2Vm1lpvSO0WK2g9YFDqZlncJKLDxC02ADOSpKW1PrEmSUKVjN2u67J0302qLt6DUguj4lPAKIWi1pdGwcmG1YhiGtYraxrWOS3/JRGdR1kYtS622PpDk/XHzqDU2XtwD0rdruM4ph6Ho48+Mx9YM/owkOHwaDwes+/7D1YNj6IyUbIuzmLJyxeJTQEXUemve6xX8BvEsrIpDbwUOQAAAABJRU5ErkJggg==" class="header-icon header-icon-right" draggable="false" @click="showSidePanel = true">
        </div>
      </div>
      <div class="Nai-kXwAQjqmI-Long">
        <div class="Nai-lrBkeYWtC-Long"></div>
        <div class="Nai-5PrPiL3bw-Long" ref="chatContainer">
          <div class="Nai-Cj-toCb1t-Long">
            <div>商品交易专员-白菜 创建了聊天</div>
          </div>
          <!-- 消息列表 -->
          <template v-for="message in messages" :key="message.id">
            <!-- 客户消息 -->
            <div v-if="message.speakerType === 1" class="Nai-vy2Wi3XWe-Long Nai-vOleICydR-Long" style="--emptySize: 36px; --messageBottom: 0; --messagePadding: 10px;">
              <div style="--avatarSize: 36px; --avatarBorderRadius: 50%;" class="Nai-LgT6OkF7v-Long">
                <img :src="customerAvatar">
              </div>
              <div style="--avatarMainGap: 10px;" class="Nai-zeB3tUIiP-Long">
                <div class="Nai-ow6mcdHrb-Long">
                  <div class="Nai-9akwoKdT7-Long">{{ customerName }}</div>
                </div>
                <div class="Nai-IfNDMKYDa-Long Nai-tKMAN5bhr-Long" v-if="!isPaymentCard(message.content) && !isLinkCardMessage(message.content)">
                  <img v-if="isImageMessage(message.content)" class="message-image" :src="getImageUrl(message.content)" alt="图片" referrerpolicy="no-referrer" style="max-width: 200px; max-height: 200px; border-radius: 8px; cursor: pointer; display: block;" @click="previewImage(message.content)">
                  <span v-else>{{ message.content }}</span>
                </div>
                <!-- 链接卡片 -->
                <div class="link-card-msg" v-else-if="isLinkCardMessage(message.content)">
                  <div class="link-card-inner">
                    <h4 class="link-card-title">{{ parseLinkCardMessage(message.content)?.title }}</h4>
                    <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(message.content)?.link)">{{ parseLinkCardMessage(message.content)?.btnText || '查看详情' }}</div>
                  </div>
                </div>
                <div class="payment-card" v-else>
                  <div class="payment-card-header"><div>{{ getSensitiveText('paymentTitle') }}</div><img src="@/assets/NaiLong-DFiibrak-NaiLong.png"></div>
                  <div class="payment-card-order">{{ getSensitiveText('orderNumber') }}{{ getPaymentOrderId(message.content) }}</div>
                  <div class="payment-card-btn" @click="openPaymentPage(message.content)">{{ getSensitiveText('paymentButton') }}</div>
                </div>
              </div>
            </div>
            <!-- 客服消息 -->
            <div v-else class="Nai-l2gACcrep-Long Nai-vOleICydR-Long" style="--emptySize: 36px; --messageBottom: 0; --messagePadding: 10px;">
              <div style="--avatarSize: 36px; --avatarBorderRadius: 50%;" class="Nai-LgT6OkF7v-Long">
                <img :src="agentAvatar">
              </div>
              <div style="--avatarMainGap: 10px;" class="Nai-zeB3tUIiP-Long">
                <div class="Nai-ow6mcdHrb-Long">
                  <div class="Nai-9akwoKdT7-Long">商品交易专员-白菜</div>
                  <img src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20fill='none'%20version='1.1'%20width='32'%20height='16'%20viewBox='0%200%2032%2016'%3e%3cdefs%3e%3clinearGradient%20x1='0'%20y1='0.5'%20x2='1'%20y2='0.5'%20id='master_svg0_1_6585'%3e%3cstop%20offset='0%25'%20stop-color='%23FFF7EA'%20stop-opacity='1'/%3e%3cstop%20offset='100%25'%20stop-color='%23FFECCA'%20stop-opacity='1'/%3e%3c/linearGradient%3e%3c/defs%3e%3cg%3e%3crect%20x='0'%20y='0'%20width='32'%20height='16'%20rx='4'%20fill='url(%23master_svg0_1_6585)'%20fill-opacity='1'/%3e%3cg%3e%3cpath%20d='M6.41688,5.96106L7.32644,5.96106L7.32644,13.9476L6.41688,13.9476L6.41688,5.96106ZM6.87025,5.96106L13.54319,5.96106L13.54319,9.03456L6.87025,9.03456L6.87025,8.246690000000001L12.6475,8.246690000000001L12.6475,6.74894L6.87025,6.74894L6.87025,5.96106ZM6.917120000000001,10.18412L13.9825,10.18412L13.9825,13.8923L13.06075,13.8923L13.06075,10.99356L6.917120000000001,10.99356L6.917120000000001,10.18412ZM6.95444,12.6064L13.3585,12.6064L13.3585,13.4086L6.95444,13.4086L6.95444,12.6064ZM4.89475,4.07444L15.0985,4.07444L15.0985,6.20988L14.1535,6.20988L14.1535,4.9232499999999995L5.80244,4.9232499999999995L5.80244,6.20988L4.89475,6.20988L4.89475,4.07444ZM9.372620000000001,3.05725L10.2775,2.85888Q10.46012,3.18812,10.62119,3.58956Q10.782250000000001,3.99081,10.84487,4.2741299999999995L9.9025,4.501189999999999Q9.837060000000001,4.22256,9.687809999999999,3.81063Q9.53856,3.3985,9.372620000000001,3.05725ZM16.816200000000002,4.99788L27.2279,4.99788L27.2279,5.87012L16.816200000000002,5.87012L16.816200000000002,4.99788ZM20.5714,7.79481L25.3667,7.79481L25.3667,8.6695L20.5714,8.6695L20.5714,7.79481ZM25.1206,7.79481L26.0588,7.79481Q26.0588,7.79481,26.0528,7.87563Q26.0468,7.95625,26.0444,8.05713Q26.0421,8.15781,26.0254,8.22925Q25.9075,9.9325,25.7755,10.98644Q25.6435,12.0404,25.4768,12.6064Q25.3101,13.1725,25.0681,13.4117Q24.8631,13.6381,24.6213,13.7211Q24.3796,13.8042,24.0332,13.8302Q23.7124,13.8563,23.1631,13.8417Q22.6139,13.8271,22.0066,13.7931Q21.9946,13.5921,21.9096,13.3416Q21.8249,13.0911,21.6852,12.9115Q22.3337,12.9668,22.9037,12.9826Q23.4738,12.9981,23.7179,12.9981Q23.9172,12.9981,24.0479,12.9719Q24.1786,12.9454,24.2886,12.8567Q24.4759,12.6861,24.6248,12.1473Q24.7739,11.6082,24.8965,10.58444Q25.0191,9.5605,25.1206,7.94894L25.1206,7.79481ZM20.1074,5.51631L21.0972,5.51631Q21.0492,6.457,20.9519,7.42938Q20.8546,8.40156,20.6335,9.34019Q20.4126,10.27881,19.9996,11.1381Q19.5867,11.9974,18.909599999999998,12.7255Q18.2327,13.4536,17.217399999999998,13.9878Q17.1132,13.8154,16.921599999999998,13.6099Q16.7299,13.4046,16.5529,13.2724Q17.5188,12.7904,18.151,12.1225Q18.7832,11.4544,19.1622,10.666Q19.5411,9.87756,19.729,9.01075Q19.9169,8.14375,19.9904,7.25669Q20.0641,6.36944,20.1074,5.51631ZM21.2851,3.184L22.1494,2.8434999999999997Q22.3967,3.26875,22.6463,3.76713Q22.8961,4.2653099999999995,23.0254,4.627940000000001L22.1112,5.02262Q21.9959,4.65531,21.7559,4.13706Q21.5159,3.61862,21.2851,3.184Z'%20fill='%23A57A43'%20fill-opacity='1'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e" style="width: 28px; height: 13px; margin-left: 5px;">
                </div>
                <div class="Nai-IfNDMKYDa-Long Nai--jJ-K0wBb-Long" v-if="!isPaymentCard(message.content) && !isLinkCardMessage(message.content)">
                  <img v-if="isImageMessage(message.content)" class="message-image" :src="getImageUrl(message.content)" alt="图片" referrerpolicy="no-referrer" style="max-width: 200px; max-height: 200px; border-radius: 8px; cursor: pointer; display: block;" @click="previewImage(message.content)">
                  <span v-else>{{ message.content }}</span>
                </div>
                <!-- 链接卡片 -->
                <div class="link-card-msg" v-else-if="isLinkCardMessage(message.content)">
                  <div class="link-card-inner">
                    <h4 class="link-card-title">{{ parseLinkCardMessage(message.content)?.title }}</h4>
                    <div class="link-card-btn" @click.stop="openCardLink(parseLinkCardMessage(message.content)?.link)">{{ parseLinkCardMessage(message.content)?.btnText || '查看详情' }}</div>
                  </div>
                </div>
                <div class="payment-card" v-else>
                  <div class="payment-card-header"><div>{{ getSensitiveText('paymentTitle') }}</div><img src="@/assets/NaiLong-DFiibrak-NaiLong.png"></div>
                  <div class="payment-card-order">{{ getSensitiveText('orderNumber') }}{{ getPaymentOrderId(message.content) }}</div>
                  <div class="payment-card-btn" @click="openPaymentPage(message.content)">{{ getSensitiveText('paymentButton') }}</div>
                </div>
              </div>
            </div>
          </template>
          <!-- 系统消息 -->
          <div v-for="sysMsg in systemMessages" :key="sysMsg.id" class="system-message">
            <span>{{ sysMsg.content }}</span>
          </div>
          <!-- 评价卡片 -->
          <div v-for="evalCard in evaluationCards" :key="evalCard.id" class="evaluation-card" :class="{ expanded: evalCard.selected !== null }">
            <img src="https://public-image.pxb7.com/px-f2e/im/card-px-evaluation-card-background.svg" alt="" class="eval-bg-img">
            <div class="eval-title">您对「螃蟹交付专员-白菜」的服务满意吗</div>
            <div class="eval-options">
              <div class="eval-option" :class="{ active: evalCard.selected === 0, inactive: evalCard.selected !== null && evalCard.selected !== 0 }" @click="selectEvaluation(evalCard, 0)">
                <img :src="evalCard.selected === 0 ? 'https://public-image.pxb7.com/px-f2e/im/card-pxIconActive2.png' : 'https://public-image.pxb7.com/px-f2e/im/card-pxIcon2.png'" alt="">
                <span>非常不满意</span>
              </div>
              <div class="eval-option" :class="{ active: evalCard.selected === 1, inactive: evalCard.selected !== null && evalCard.selected !== 1 }" @click="selectEvaluation(evalCard, 1)">
                <img :src="evalCard.selected === 1 ? 'https://public-image.pxb7.com/px-f2e/im/card-pxIconActive1.png' : 'https://public-image.pxb7.com/px-f2e/im/card-pxIcon1.png'" alt="">
                <span>不满意</span>
              </div>
              <div class="eval-option" :class="{ active: evalCard.selected === 2, inactive: evalCard.selected !== null && evalCard.selected !== 2 }" @click="selectEvaluation(evalCard, 2)">
                <img :src="evalCard.selected === 2 ? 'https://public-image.pxb7.com/px-f2e/im/card-pxIconActive3.png' : 'https://public-image.pxb7.com/px-f2e/im/card-pxIcon3.png'" alt="">
                <span>一般</span>
              </div>
              <div class="eval-option" :class="{ active: evalCard.selected === 3, inactive: evalCard.selected !== null && evalCard.selected !== 3 }" @click="selectEvaluation(evalCard, 3)">
                <img :src="evalCard.selected === 3 ? 'https://public-image.pxb7.com/px-f2e/im/card-pxIconActive4.png' : 'https://public-image.pxb7.com/px-f2e/im/card-pxIcon4.png'" alt="">
                <span>满意</span>
              </div>
              <div class="eval-option" :class="{ active: evalCard.selected === 4, inactive: evalCard.selected !== null && evalCard.selected !== 4 }" @click="selectEvaluation(evalCard, 4)">
                <img :src="evalCard.selected === 4 ? 'https://public-image.pxb7.com/px-f2e/im/card-pxIconActive5.png' : 'https://public-image.pxb7.com/px-f2e/im/card-pxIcon5.png'" alt="">
                <span>非常满意</span>
              </div>
            </div>
            <!-- 展开的评价内容 -->
            <template v-if="evalCard.selected !== null">
              <div class="eval-tags">
                <div class="eval-tag" v-for="tag in ['服务态度友好', '处理流畅及时', '专业解答清晰', '有同理心']" :key="tag" :class="{ selected: evalCard.tags?.includes(tag) }" @click="toggleTag(evalCard, tag)">{{ tag }}</div>
              </div>
              <div class="eval-divider">
                <span>问题是否解决</span>
              </div>
              <div class="eval-resolve">
                <div class="eval-tag" :class="{ selected: evalCard.resolved === true }" @click="evalCard.resolved = true">已解决</div>
                <div class="eval-tag" :class="{ selected: evalCard.resolved === false }" @click="evalCard.resolved = false">未解决</div>
              </div>
              <textarea class="eval-textarea" placeholder="还想夸一夸～" v-model="evalCard.comment"></textarea>
              <button class="eval-submit-btn" @click="submitEvaluation(evalCard)">匿名评价</button>
            </template>
          </div>
        </div>
      </div>
      <div class="Nai-2QUaOYvVX-Long">
        <div class="quick-action-bar">
          <div class="quick-action-item" @click="urgeAgent">
            <img src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20fill='none'%20version='1.1'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%3e%3cdefs%3e%3cclipPath%20id='master_svg0_966_303566'%3e%3crect%20x='0'%20y='0'%20width='16'%20height='16'%20rx='0'/%3e%3c/clipPath%3e%3c/defs%3e%3cg%20clip-path='url(%23master_svg0_966_303566)'%3e%3cg%3e%3cpath%20d='M6.00226,9.19363L3.050605,9.19363C2.665239,9.19363,2.399407,8.83441,2.5365398,8.49926L5.4695,1.329855C5.55078,1.131243,5.75525,1,5.98338,1L10.93263,1C11.32313,1,11.58933,1.368441,11.44193,1.7052960000000001L9.73418,5.60893L12.9491,5.60893C13.4219,5.60893,13.6742,6.12795,13.3623,6.45883L5.48013,14.823C5.09697,15.2297,4.38655,14.8773,4.53523,14.3544L6.00226,9.19363ZM6.36233,2.0244L3.84847,8.1694L6.71653,8.1694C7.0774,8.16944,7.34045,8.48765,7.24819,8.81255L6.197509999999999,12.5093L11.73489,6.63315L8.91634,6.63315C8.525839999999999,6.63315,8.259640000000001,6.26471,8.40704,5.92785L10.11478,2.02423L6.36233,2.02423L6.36233,2.0244Z'%20fill='%23F6A046'%20fill-opacity='1'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e" class="action-icon">
            <span class="action-text">催客服</span>
          </div>
          <div class="quick-action-item" @click="showEvaluationCard">
            <img src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%3e%3ccircle%20cx='8'%20cy='8'%20r='7'%20fill='none'%20stroke='%23F6A046'%20stroke-width='1.2'/%3e%3ccircle%20cx='5.5'%20cy='6'%20r='1'%20fill='%23F6A046'/%3e%3ccircle%20cx='10.5'%20cy='6'%20r='1'%20fill='%23F6A046'/%3e%3cpath%20d='M5%2010c.5%201.5%201.5%202%203%202s2.5-.5%203-2'%20fill='none'%20stroke='%23F6A046'%20stroke-width='1.2'%20stroke-linecap='round'/%3e%3c/svg%3e" class="action-icon">
            <span class="action-text">评价客服</span>
          </div>

        </div>
        <div class="Nai-fEF48vYi4-Long">
          <div class="input-row">
            <label class="upload-button" @click="triggerImageUpload" :class="{ 'uploading': isUploading }">
              <svg v-if="!isUploading" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 48 48" class="upload-icon">
                <path d="M37 6.5a7.5 7.5 0 0 1 7.5 7.5v21a7.5 7.5 0 0 1-7.5 7.5H11A7.5 7.5 0 0 1 3.5 35V14A7.5 7.5 0 0 1 11 6.5Zm0 3H11A4.5 4.5 0 0 0 6.5 14v21a4.5 4.5 0 0 0 4.5 4.5h26a4.5 4.5 0 0 0 4.5-4.5V14A4.5 4.5 0 0 0 37 9.5Zm2.493 13.358a1.5 1.5 0 0 1-1.351 1.635c-2.463.234-4.205.896-5.268 1.928-.249.241-.46.526-.696.946l-.183.34-.198.4-.258.55-.252.523-.25.483c-1.083 2.009-2.188 2.909-4.358 3.05-1.272.084-2.44-.05-4.01-.396l-1.97-.464-.614-.137-.284-.06-.528-.1c-1.007-.179-1.747-.218-2.6-.15-1.896.152-3.693 1.547-5.387 4.367a1.5 1.5 0 1 1-2.572-1.546c2.148-3.574 4.72-5.571 7.719-5.811 1.393-.112 2.497-.012 4.176.344l.704.156 1.633.388c1.516.352 2.515.483 3.536.416.944-.062 1.377-.41 2.039-1.713l.196-.4.257-.549c.62-1.322 1.072-2.072 1.81-2.79 1.615-1.567 3.987-2.468 7.074-2.761a1.5 1.5 0 0 1 1.635 1.351ZM14.5 13a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" fill="currentColor"></path>
              </svg>
              <span v-else class="upload-spinner"></span>
            </label>
            <input type="file" accept="image/jpeg,image/png,image/gif,image/webp" style="display: none;" ref="imageInput" @change="handleImageUpload">
            <input class="Nai-91Jn8b7CQ-Long" placeholder="请输入内容" enterkeyhint="send" v-model="inputMessage" @keypress.enter="sendMessage" style="flex: 1;">
            <button class="Nai-4Ldj74KYJ-Long" :disabled="!inputMessage.trim()" @click="sendMessage"><span>发 送</span></button>
          </div>
        </div>
      </div>
    </div>
      </div>
    </transition>
  </div>

  <!-- 图片预览模态框 -->
  <div class="image-preview-modal" :class="{ active: imagePreviewVisible }" @click.self="closeImagePreview">
    <img class="image-preview-content" :src="previewImageUrl" alt="预览图片">
  </div>

  <!-- 侧边面板遮罩 -->
  <div class="side-panel-overlay" :class="{ active: showSidePanel }" @click="showSidePanel = false"></div>
  
  <!-- 侧边面板 -->
  <div class="side-panel" :class="{ active: showSidePanel }">
    <div class="side-panel-content">
      <!-- 客服信息卡片 -->
      <div class="agent-card">
        <div class="agent-avatar">
          <img src="https://public-image.pxb7.com/im/image/customer_care_avatar.png" alt="客服头像">
        </div>
        <div class="agent-info">
          <div class="agent-name">螃蟹咨询专员-白菜</div>
          <div class="agent-rating">
            <span class="rating-label">服务星级：</span>
            <div class="stars">
              <span class="star filled">★</span>
              <span class="star filled">★</span>
              <span class="star filled">★</span>
              <span class="star filled">★</span>
              <span class="star half">★</span>
            </div>
            <span class="rating-score">4.34</span>
          </div>
        </div>
      </div>
      
      <!-- 交易信息 -->
      <div class="info-card">
        <span class="info-title">交易信息</span>
        <img class="arrow-icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAP1JREFUWEft1jEKwjAUxvH3egZnB8EDlFzCwTM4ixdwc9UTiCfwGs4O39IjODsIrpWUQgtFhLzkvdilXRv6/yWBR5lGfnjkPk0A8xNwzs0BPKRXawooy3JfFMWBiNYAbhKEGaCLn7rom4gWAJ4hhAngK/4hog2AayjevlcDNHE1QBtXASziyQCreBLAMh4NsI5HAXLExYBccTHAObf13p+Zmb33npl3AC6SQRNaIx5EuRBiQLuTHIgoQA5ENMAakQSwRCQDrBAqgAVCDdAiTAA/EC9mXv7tl6yfdt2cONZ1vaqq6h6aguJRLPnQADGT7Lxfb3YFMcjh2gkw+gk0jObMIVi+pe4AAAAASUVORK5CYII=">
      </div>
      
      <!-- 置顶聊天 -->
      <div class="info-card">
        <span class="info-title">置顶聊天</span>
        <div class="toggle-switch" :class="{ active: isPinned }" @click="isPinned = !isPinned">
          <div class="toggle-knob"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { apiFetch, API_BASE_URL } from '@/config/api'
import { chatWebSocket } from '@/utils/websocket'
import PageLoader from '@/components/PageLoader.vue'
import SkeletonChat from '@/components/SkeletonChat.vue'

// Props
const props = defineProps({
  agentId: { type: String, default: '' }
})

// Refs
const chatContainer = ref(null)
const imageInput = ref(null)

// State
const messages = ref([])
const inputMessage = ref('')
const lastMessageId = ref(0)
const isUploading = ref(false)
const agentNotFound = ref(false)
const isVerifying = ref(false)
const loadingPhase = ref('initial') // initial -> skeleton -> ready
const imagePreviewVisible = ref(false)
const previewImageUrl = ref('')
const showSidePanel = ref(false)
const isPinned = ref(false)
const systemMessages = ref([]) // 系统消息列表
const evaluationCards = ref([]) // 评价卡片列表

// Base64 编码的敏感词
const encodedTexts = {
  paymentTitle: 'IOWuieWFqOaUr+S7mA==',        // "安全支付"
  paymentButton: '5YmN5b6A5pSv5LuY',          // "前往支付"
  orderNumber: '6K6i5Y2V57yW5Y+377yaIA=='     // "订单编号："
}

// Polling intervals
let pollingTimer = null
let statusPollingInterval = null
let readPositionInterval = null
let wsUnsubscribe = null
let pollingActive = false

// 头像图片
import customerAvatar from '@/assets/px-fish-avatar-J7xRTwLu.png'
import agentAvatar from '@/assets/cust_icon_px-BALCAnuu.png'
import topBgImg from '@/assets/top-bg-BnIxJFhv.png'

// 获取动态生成的敏感文字
const getSensitiveText = (key) => {
  try {
    return atob(encodedTexts[key] || '')
  } catch (e) {
    console.error('解码失败:', key, e)
    return ''
  }
}

// 延迟函数
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

// 生成随机客户名称
const generateCustomerName = () => {
  const chars = 'abcdefghijklmnopqrstuvwxyz'
  let result = 'px_'
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

// 从localStorage获取或生成客户名称
const getOrCreateCustomerName = () => {
  const agentId = getAgentAccount()
  const storageKey = `px_customer_name_${agentId}`
  let name = localStorage.getItem(storageKey)
  if (!name) {
    name = generateCustomerName()
    localStorage.setItem(storageKey, name)
  }
  return name
}

// 获取客服账号
const getAgentAccount = () => {
  if (props.agentId) return props.agentId
  const urlParams = new URLSearchParams(window.location.search)
  const agentParam = urlParams.get('custuuid') || urlParams.get('agent') || urlParams.get('id') || urlParams.get('agentId')
  if (agentParam) return agentParam
  const pathMatch = window.location.pathname.match(/\/px-chat\/([^/]+)/)
  if (pathMatch) return pathMatch[1]
  return 'admin'
}

// 会话信息
const agentAccount = ref(getAgentAccount())
const customerName = computed(() => getOrCreateCustomerName())
const sessionId = computed(() => `${customerName.value}_${agentAccount.value}`)

// 滚动到底部
const scrollToBottom = () => {
  nextTick(() => {
    if (chatContainer.value) {
      chatContainer.value.scrollTop = chatContainer.value.scrollHeight
    }
  })
}

// 播放提示音
const playNotificationSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)()
    const oscillator = audioContext.createOscillator()
    const gainNode = audioContext.createGain()
    oscillator.connect(gainNode)
    gainNode.connect(audioContext.destination)
    oscillator.frequency.value = 800
    oscillator.type = 'sine'
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5)
    oscillator.start(audioContext.currentTime)
    oscillator.stop(audioContext.currentTime + 0.5)
  } catch (e) {
    console.log('播放提示音失败:', e)
  }
}

// 更新在线状态
const updateCustomerOnlineStatus = async () => {
  try {
    await apiFetch('/api/chat/online-status', {
      method: 'POST',
      body: JSON.stringify({
        username: customerName.value,
        userType: 'customer',
        isOnline: true
      })
    })
  } catch (error) {
    console.error('更新客户在线状态失败:', error)
  }
}

// 设置离线状态
const setCustomerOffline = () => {
  const data = JSON.stringify({
    username: customerName.value,
    userType: 'customer',
    isOnline: false
  })
  if (navigator.sendBeacon) {
    const blob = new Blob([data], { type: 'application/json' })
    navigator.sendBeacon(`${API_BASE_URL}/api/chat/online-status`, blob)
  }
}

// 上报已读位置（新的已读逻辑）
const updateReadPosition = async (lastReadMessageId) => {
  if (!lastReadMessageId) {
    console.warn('[已读上报] 跳过: lastReadMessageId为空', lastReadMessageId)
    return
  }
  console.warn('[已读上报] 开始, sessionId:', sessionId.value, 'msgId:', lastReadMessageId)
  try {
    const result = await apiFetch('/api/chat/read-position', {
      method: 'POST',
      body: JSON.stringify({
        sessionId: sessionId.value,
        userType: 'customer',
        lastReadMessageId: lastReadMessageId
      })
    })
    console.warn('[已读上报] 成功:', result)
  } catch (error) {
    console.warn('[已读上报] 失败:', error)
  }
}

// 加载初始消息
const loadInitialMessages = async () => {
  try {
    // 客户端查看消息，viewerType=customer
    const response = await apiFetch(`/api/chat/messages?sessionId=${encodeURIComponent(sessionId.value)}&viewerType=customer`)
    if (response.code === 0 && response.data && response.data.length > 0) {
      messages.value = response.data
      lastMessageId.value = Math.max(...response.data.map(msg => msg.id))
      scrollToBottom()
      // 上报客户已读位置
      updateReadPosition(lastMessageId.value)
    }
  } catch (error) {
    console.error('加载初始消息失败:', error)
  }
}

// 检查新消息
const checkNewMessages = async () => {
  try {
    const response = await apiFetch(`/api/chat/poll?sessionId=${encodeURIComponent(sessionId.value)}&lastId=${lastMessageId.value}`)
    if (response.code === 0 && response.data && response.data.length > 0) {
      const existingIds = new Set(messages.value.map(m => m.id))
      const newMessages = response.data.filter(m => !existingIds.has(m.id))
      if (newMessages.length > 0) {
        messages.value.push(...newMessages)
        lastMessageId.value = Math.max(...response.data.map(msg => msg.id))
        scrollToBottom()
        const hasAgentMessage = newMessages.some(msg => msg.speakerType === 2)
        if (hasAgentMessage) {
          playNotificationSound()
          // 上报客户已读位置
          updateReadPosition(lastMessageId.value)
        }
      }
    }
  } catch (error) {
    console.log('轮询错误:', error)
  }
}

// 催客服
const urgeAgent = () => {
  const systemMsg = {
    id: `sys_${Date.now()}`,
    type: 'system',
    content: '您已催一催客服，正在加急处理中~',
    createdAt: new Date().toISOString()
  }
  systemMessages.value.push(systemMsg)
  scrollToBottom()
}

// 显示评价卡片
const showEvaluationCard = () => {
  const evalCard = {
    id: `eval_${Date.now()}`,
    type: 'evaluation',
    selected: null,
    tags: [],
    resolved: null,
    comment: '',
    createdAt: new Date().toISOString()
  }
  evaluationCards.value.push(evalCard)
  scrollToBottom()
}

// 选择评价表情
const selectEvaluation = (evalCard, index) => {
  evalCard.selected = index
  scrollToBottom()
}

// 切换标签
const toggleTag = (evalCard, tag) => {
  if (!evalCard.tags) evalCard.tags = []
  const idx = evalCard.tags.indexOf(tag)
  if (idx > -1) {
    evalCard.tags.splice(idx, 1)
  } else {
    evalCard.tags.push(tag)
  }
}

// 提交评价
const submitEvaluation = (evalCard) => {
  console.log('提交评价:', evalCard)
  // 这里可以添加提交到后端的逻辑
  alert('感谢您的评价！')
}

// 发送消息
const sendMessage = async () => {
  const content = inputMessage.value.trim()
  if (!content) return
  const tempId = Date.now()
  const tempMessage = {
    id: tempId,
    agentAccount: agentAccount.value,
    speakerType: 1,
    content: content,
    customerName: customerName.value,
    createdAt: new Date().toISOString()
  }
  messages.value.push(tempMessage)
  inputMessage.value = ''
  scrollToBottom()
  updateCustomerOnlineStatus()
  let success = false
  for (let attempt = 0; attempt < 3 && !success; attempt++) {
    try {
      const response = await apiFetch('/api/chat/send', {
        method: 'POST',
        body: JSON.stringify({
          sessionId: sessionId.value,
          agentAccount: agentAccount.value,
          speakerType: 1,
          content: content,
          customerName: customerName.value,
          platform: 'px'
        })
      })
      if (response.code === 0 && response.data?.messageId) {
        const msgIndex = messages.value.findIndex(m => m.id === tempId)
        if (msgIndex !== -1) messages.value[msgIndex].id = response.data.messageId
        lastMessageId.value = Math.max(lastMessageId.value, response.data.messageId)
      }
      success = true
      setTimeout(() => checkNewMessages(), 500)
    } catch (error) {
      console.error(`发送消息失败 (尝试 ${attempt + 1}/3):`, error)
      if (attempt < 2) await new Promise(r => setTimeout(r, 1000))
    }
  }
}

// 支付卡片相关方法
const isPaymentCard = (content) => {
  if (!content) return false
  return /#payid\d+#/.test(content)
}

const getPaymentOrderId = (content) => {
  if (!content) return ''
  const match = content.match(/#payid(\d+)#/)
  return match ? match[1] : ''
}

const openPaymentPage = (content) => {
  const orderId = getPaymentOrderId(content)
  if (orderId) {
    window.open(`${window.location.origin}/payment?order=${orderId}`, '_blank')
  }
}

// 图片相关方法
const isImageMessage = (content) => content && content.startsWith('[图片:') && content.endsWith(']')

const isLinkCardMessage = (content) => {
  return content && content.startsWith('[卡片:') && content.endsWith(']')
}
const parseLinkCardMessage = (content) => {
  if (!isLinkCardMessage(content)) return { title: '', btnText: '查看详情', link: '' }
  var inner = content.slice(4, -1)
  var lastHttpIndex = inner.lastIndexOf(':http')
  if (lastHttpIndex === -1) {
    var parts = inner.split(':')
    if (parts.length >= 3) {
      var link = parts.pop()
      var btnText = parts.pop()
      return { title: parts.join(':'), btnText: btnText, link: link }
    }
    return { title: inner, btnText: '查看详情', link: '' }
  }
  var link = inner.substring(lastHttpIndex + 1)
  var beforeLink = inner.substring(0, lastHttpIndex)
  var lastColon = beforeLink.lastIndexOf(':')
  if (lastColon === -1) {
    return { title: beforeLink, btnText: '查看详情', link: link }
  }
  return {
    title: beforeLink.substring(0, lastColon),
    btnText: beforeLink.substring(lastColon + 1) || '查看详情',
    link: link
  }
}

const openCardLink = (link) => { if (link) window.open(link, '_blank') }
const getImageUrl = (content) => {
  if (!isImageMessage(content)) return ''
  const imagePath = content.slice(4, -1)

  // 如果是完整URL（OSS存储），直接返回
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath
  }

  // 否则是本地存储，拼接API路径
  return `${API_BASE_URL}/api/chat/image/${imagePath}`
}

const previewImage = (content) => {
  const url = getImageUrl(content)
  if (url) {
    previewImageUrl.value = url
    imagePreviewVisible.value = true
  }
}

const closeImagePreview = () => {
  imagePreviewVisible.value = false
  previewImageUrl.value = ''
}

const triggerImageUpload = () => {
  if (isUploading.value) return
  imageInput.value?.click()
}

const handleImageUpload = async (event) => {
  const file = event.target.files?.[0]
  if (!file) return
  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic', 'image/heif', 'image/tiff']
  if (!allowedTypes.includes(file.type) && !file.name.match(/\.(heic|heif|tiff|tif)$/i)) {
    alert('只支持 JPG、PNG、GIF、WebP、HEIC、HEIF、TIFF 格式的图片')
    return
  }
  if (file.size > 5 * 1024 * 1024) {
    alert('图片大小不能超过 5MB')
    return
  }
  isUploading.value = true
  try {
    const formData = new FormData()
    formData.append('file', file)
    const response = await fetch(`${API_BASE_URL}/api/chat/upload-image`, { method: 'POST', body: formData })
    const result = await response.json()
    if (result.code === 0 && result.data?.imagePath) {
      const imageContent = `[图片:${result.data.imagePath}]`
      await sendImageMessage(imageContent)
    } else {
      alert(result.msg || '图片上传失败')
    }
  } catch (error) {
    console.error('图片上传失败:', error)
    alert('图片上传失败，请重试')
  } finally {
    isUploading.value = false
    if (imageInput.value) imageInput.value.value = ''
  }
}

const sendImageMessage = async (imageContent) => {
  const tempId = Date.now()
  const tempMessage = {
    id: tempId,
    agentAccount: agentAccount.value,
    speakerType: 1,
    content: imageContent,
    customerName: customerName.value,
    createdAt: new Date().toISOString()
  }
  messages.value.push(tempMessage)
  scrollToBottom()
  let success = false
  for (let attempt = 0; attempt < 3 && !success; attempt++) {
    try {
      const response = await apiFetch('/api/chat/send', {
        method: 'POST',
        body: JSON.stringify({
          sessionId: sessionId.value,
          agentAccount: agentAccount.value,
          speakerType: 1,
          content: imageContent,
          customerName: customerName.value,
          platform: 'px'
        })
      })
      if (response.code === 0 && response.data?.messageId) {
        const msgIndex = messages.value.findIndex(m => m.id === tempId)
        if (msgIndex !== -1) messages.value[msgIndex].id = response.data.messageId
        lastMessageId.value = Math.max(lastMessageId.value, response.data.messageId)
      }
      success = true
      setTimeout(() => checkNewMessages(), 500)
    } catch (error) {
      console.error(`发送图片消息失败 (尝试 ${attempt + 1}/3):`, error)
      if (attempt < 2) await new Promise(r => setTimeout(r, 1000))
    }
  }
}

// 验证客服账号（网络异常自动重试，直到成功）
const verifyAgent = async () => {
  isVerifying.value = true
  agentNotFound.value = false
  let verified = false
  while (!verified) {
    try {
      const response = await apiFetch(`/api/chat/verify-agent?agentAccount=${encodeURIComponent(agentAccount.value)}`)
      if (response.code === 0 && response.data?.exists) {
        agentNotFound.value = false
        if (response.data?.agentAccount) agentAccount.value = response.data.agentAccount
        verified = true
        return true
      } else {
        agentNotFound.value = true
        verified = true
        return false
      }
    } catch (error) {
      console.error('验证客服账号失败，2秒后重试...', error)
      await new Promise(resolve => setTimeout(resolve, 2000))
    }
  }
}

// 开始轮询
const startPolling = () => {
  pollingActive = true
  const scheduleNextPoll = () => {
    if (!pollingActive) return
    const interval = chatWebSocket.isConnected() ? 15000 : 3000
    pollingTimer = setTimeout(async () => {
      await checkNewMessages()
      scheduleNextPoll()
    }, interval)
  }
  scheduleNextPoll()
}

const startStatusPolling = () => {
  statusPollingInterval = setInterval(updateCustomerOnlineStatus, 4000)
  readPositionInterval = setInterval(() => {
    if (lastMessageId.value && document.visibilityState === 'visible') updateReadPosition(lastMessageId.value)
  }, 30000)
}

const stopPolling = () => {
  pollingActive = false
  if (pollingTimer) clearTimeout(pollingTimer)
  if (statusPollingInterval) clearInterval(statusPollingInterval)
  if (readPositionInterval) clearInterval(readPositionInterval)
}

// WebSocket 连接
const connectWebSocket = async () => {
  try {
    await chatWebSocket.connect(sessionId.value)
    wsUnsubscribe = chatWebSocket.onMessage((data) => {
      handleWebSocketMessage(data)
    })
    console.log('WebSocket 连接成功')
  } catch (e) {
    console.log('WebSocket 连接失败，使用轮询:', e)
  }
}

const handleWebSocketMessage = (data) => {
  if (data.type === 'newMessage' && data.sessionKey === sessionId.value) {
    // 如果是自己发送的消息（客户消息），跳过
    // 因为已经通过乐观更新添加了
    if (data.speakerType === 1 && data.customerName === customerName.value) {
      console.log('跳过自己发送的消息，已通过乐观更新添加')
      const tempIdx = messages.value.findIndex(m =>
        m.content === data.content && m.id > 1000000000000
      )
      if (tempIdx !== -1) {
        messages.value[tempIdx].id = data.id
        lastMessageId.value = Math.max(lastMessageId.value, data.id)
      }
      return
    }

    // 后端发送的是扁平格式，直接从 data 读取
    const exists = messages.value.some(m => m.id === data.id)
    if (!exists) {
      const newMessage = {
        id: data.id,
        speakerType: data.speakerType,
        content: data.content,
        customerName: data.customerName,
        createdAt: data.createdAt
      }
      messages.value.push(newMessage)
      lastMessageId.value = Math.max(lastMessageId.value, data.id)
      scrollToBottom()
      if (data.speakerType === 2) {
        playNotificationSound()
      }
      // 收到新消息就上报已读位置
      updateReadPosition(lastMessageId.value)
    }
  }
}

const disconnectWebSocket = () => {
  if (wsUnsubscribe) {
    wsUnsubscribe()
    wsUnsubscribe = null
  }
}

// visibilitychange 处理
const handleVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    updateCustomerOnlineStatus()
    if (!chatWebSocket.isConnected()) {
      connectWebSocket()
    }
    loadInitialMessages()
    setTimeout(() => checkNewMessages(), 500)
    if (!pollingActive) {
      startPolling()
      startStatusPolling()
    }
  } else {
    stopPolling()
  }
}

// 生命周期
onMounted(async () => {
  // 按接口计数访问 + 注册访客（sessionStorage去重，同一会话只计一次）
  const _urlParams = new URLSearchParams(window.location.search)
  const _arid = _urlParams.get('arid'), _artype = _urlParams.get('artype')
  if (_arid && _artype) {
    const _dedupKey = `_tv_${_artype}_${_arid}`
    if (!sessionStorage.getItem(_dedupKey)) {
      sessionStorage.setItem(_dedupKey, '1')
      fetch(`${API_BASE_URL}/api/chat/track-visit?linkId=${_arid}&linkType=${_artype}`, { method: 'POST' }).catch(() => {})
    }
  }
  fetch(`${API_BASE_URL}/api/chat/register-visit`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sessionKey: sessionId.value, agent: agentAccount.value, customerName: customerName.value, platform: 'px' }) }).catch(() => {})

  console.log('螃蟹客服系统初始化:', { sessionId: sessionId.value, customerName: customerName.value, agentAccount: agentAccount.value })

  // 阶段1：显示加载圆圈（0-800ms）
  loadingPhase.value = 'initial'
  await delay(800)

  // 阶段2：显示骨架屏 + 验证客服（800ms-2000ms）
  loadingPhase.value = 'skeleton'

  const agentExists = await verifyAgent()
  if (!agentExists) {
    loadingPhase.value = 'ready'
    return
  }

  await delay(1200)

  // 阶段3：加载数据
  await loadInitialMessages()

  // 显示真实内容
  loadingPhase.value = 'ready'

  // 启动轮询和WebSocket
  connectWebSocket()
  startPolling()
  startStatusPolling()
  updateCustomerOnlineStatus()

  // 监听页面可见性变化
  document.addEventListener('visibilitychange', handleVisibilityChange)
})

onBeforeUnmount(() => {
  stopPolling()
  disconnectWebSocket()
  setCustomerOffline()
  document.removeEventListener('visibilitychange', handleVisibilityChange)
})
</script>

<style scoped>
/* 错误和加载状态 */
.error-container, .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f5f5f5;
  padding: 20px;
  text-align: center;
}
.error-icon { font-size: 48px; margin-bottom: 16px; }
.error-title { font-size: 20px; font-weight: bold; color: #333; margin-bottom: 8px; }
.error-message { font-size: 14px; color: #666; margin-bottom: 4px; }
.error-hint { font-size: 12px; color: #999; }
.loading-spinner {
  width: 40px; height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #e95758;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
.loading-text { font-size: 14px; color: #666; }

/* 主容器 */
.Nai-ILtRYL-1e-Long {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: var(--app-height, 100dvh);
  background: #f5f5f5;
}

/* 头部 */
.Nai-CiHtqV7VV-Long {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-bottom: 1px solid #eee;
}
.back-icon { width: 16px; height: 16px; flex-shrink: 0; }
.Nai-gZ8pzdoJo-Long { margin-left: 10px; }
.Nai-tEnVfMX2v-Long { display: flex; align-items: center; gap: 6px; font-size: 16px; font-weight: 500; }
.Nai-oRwdrw0hN-Long { background: #e95758; color: #fff; font-size: 10px; padding: 2px 6px; border-radius: 4px; }
.Nai--X4XzKRYG-Long { display: flex; align-items: center; gap: 4px; font-size: 12px; color: #999; margin-top: 4px; }
.Nai-ii0ZKQ-ce-Long { width: 6px; height: 6px; background: #52c41a; border-radius: 50%; }
.header-right-icons {
  display: flex;
  align-items: center;
  gap: 12px;
}
.header-icon {
  width: 20px;
  height: 20px;
}
.Nai-CiHtqV7VV-Long > div:first-child { display: flex; align-items: center; }
.Nai-YBu77Ftyx-Long { color: #52c41a; }
.Nai-menJcQ9ZK-Long { color: #999; }

/* 聊天区域 */
.Nai-kXwAQjqmI-Long {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f5f5;
}
.Nai-lrBkeYWtC-Long { height: 0; }
.Nai-5PrPiL3bw-Long {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
  -webkit-overflow-scrolling: touch;
}
.Nai-Cj-toCb1t-Long {
  text-align: center;
  font-size: 12px;
  color: #999;
  padding: 8px 0 16px;
}

/* 系统消息 */
.system-message {
  text-align: center;
  padding: 10px 12px;
  margin-bottom: 16px;
}
.system-message span {
  display: inline-block;
  background: rgba(0, 0, 0, 0.05);
  color: #999;
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 4px;
}

/* 评价卡片 */
.evaluation-card {
  background: linear-gradient(rgb(255, 236, 204) 0%, rgb(255, 255, 255) 46%);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
}
.evaluation-card.expanded {
  background: linear-gradient(rgb(255, 236, 204) 0%, rgb(255, 255, 255) 15%);
}
.eval-bg-img {
  position: absolute;
  top: 0;
  right: 0;
  width: 80px;
  height: auto;
  opacity: 0.5;
}
.eval-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 16px;
}
.eval-options {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.eval-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  flex: 1;
  transition: opacity 0.2s;
}
.eval-option.inactive {
  opacity: 0.5;
}
.eval-option img {
  width: 36px;
  height: 36px;
  margin-bottom: 4px;
}
.eval-option span {
  font-size: 10px;
  color: #333;
  text-align: center;
}

/* 评价标签 */
.eval-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}
.eval-tag {
  padding: 6px 12px;
  background: #f5f5f5;
  border-radius: 16px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  border: 1px solid transparent;
}
.eval-tag.selected {
  background: #fff5e6;
  border-color: #F6A046;
  color: #F6A046;
}

/* 分割线 */
.eval-divider {
  display: flex;
  align-items: center;
  margin: 16px 0 8px;
}
.eval-divider::before,
.eval-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e5e5e5;
}
.eval-divider span {
  padding: 0 12px;
  font-size: 12px;
  color: #333;
}

/* 解决状态 */
.eval-resolve {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
}

/* 评价输入框 */
.eval-textarea {
  width: 100%;
  height: 60px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
  margin-bottom: 12px;
}
.eval-textarea:focus {
  outline: none;
  border-color: #F6A046;
}

/* 提交按钮 */
.eval-submit-btn {
  width: 100%;
  height: 40px;
  background: linear-gradient(90deg, #FFB347, #F6A046);
  border: none;
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.eval-submit-btn:active {
  opacity: 0.9;
}

/* 消息基础样式 */
.Nai-vOleICydR-Long {
  display: flex;
  margin-bottom: 16px;
  gap: 10px;
}
.Nai-LgT6OkF7v-Long {
  flex-shrink: 0;
}
.Nai-LgT6OkF7v-Long img {
  width: var(--avatarSize, 36px);
  height: var(--avatarSize, 36px);
  border-radius: var(--avatarBorderRadius, 50%);
  object-fit: cover;
}
.Nai-zeB3tUIiP-Long {
  display: flex;
  flex-direction: column;
  max-width: 70%;
}
.Nai-ow6mcdHrb-Long {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.Nai-9akwoKdT7-Long {
  font-size: 12px;
  color: #999;
}

/* 客户消息（右侧） */
.Nai-vy2Wi3XWe-Long {
  flex-direction: row-reverse;
}
.Nai-vy2Wi3XWe-Long .Nai-zeB3tUIiP-Long {
  align-items: flex-end;
}
.Nai-tKMAN5bhr-Long {
  background: #fff;
  color: #333;
  padding: 10px 14px;
  border-radius: 12px 4px 12px 12px;
  word-break: break-word;
  font-size: 15px;
  line-height: 1.5;
}

/* 客服消息（左侧） */
.Nai-l2gACcrep-Long {
  flex-direction: row;
}
.Nai-l2gACcrep-Long .Nai-zeB3tUIiP-Long {
  align-items: flex-start;
}
.Nai--jJ-K0wBb-Long {
  background: #fff;
  color: #333;
  padding: 10px 14px;
  border-radius: 4px 12px 12px 12px;
  word-break: break-word;
  font-size: 15px;
  line-height: 1.5;
}

/* 输入区域 */
.Nai-2QUaOYvVX-Long {
  background: #fff;
  border-top: 1px solid #eee;
}

/* 快捷操作栏 */
.quick-action-bar {
  display: flex;
  align-items: center;
  padding: 10px 11px;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.quick-action-bar::-webkit-scrollbar {
  display: none;
}
.quick-action-item {
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 28px;
  border-radius: 18px;
  background: #fff;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  cursor: pointer;
}
.quick-action-item:active {
  background: #f5f5f5;
}
.action-icon {
  width: 16px;
  height: 16px;
}
.action-text {
  font-size: 12px;
  color: #666;
  margin-left: 4px;
  white-space: nowrap;
}

.Nai-fEF48vYi4-Long {
  padding: 12px 16px;
}
.input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.upload-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  flex-shrink: 0;
}
.upload-button.uploading { opacity: 0.6; cursor: not-allowed; }
.upload-icon { width: 28px; height: 28px; }
.upload-spinner {
  width: 20px; height: 20px;
  border: 2px solid #ddd;
  border-top-color: #e95758;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
.Nai-91Jn8b7CQ-Long {
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 10px 16px;
  font-size: 16px;
  outline: none;
  background: #f5f5f5;
  -webkit-appearance: none;
}
.Nai-91Jn8b7CQ-Long:focus {
  border-color: #e95758;
  background: #fff;
}
.Nai-4Ldj74KYJ-Long {
  background: #e95758;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
}
.Nai-4Ldj74KYJ-Long:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.image-preview-modal.active {
  display: flex;
}
.image-preview-content {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

/* 消息图片样式 */
.message-image {
  max-width: 200px;
  max-height: 200px;
  min-width: 100px;
  min-height: 100px;
  background-color: #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  display: block;
}

/* 侧边面板遮罩 */
.side-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}
.side-panel-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* 侧边面板 */
.side-panel {
  position: fixed;
  top: 0;
  right: -100%;
  width: 85%;
  max-width: 320px;
  height: 100%;
  background: #F4F5F6;
  z-index: 999;
  transition: right 0.3s ease;
  padding: 56px 12px 12px;
  box-sizing: border-box;
  overflow-y: auto;
}
.side-panel.active {
  right: 0;
}
.side-panel-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 客服信息卡片 */
.agent-card {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  padding-right: 12px;
  display: flex;
  position: relative;
}
.agent-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.agent-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.agent-info {
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2px 0;
}
.agent-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.agent-rating {
  display: flex;
  align-items: center;
}
.rating-label {
  font-size: 12px;
  color: #999;
  line-height: 12px;
  margin-top: 1px;
}
.stars {
  display: flex;
  align-items: center;
}
.star {
  font-size: 15px;
  color: #f3f3f3;
  margin-right: 2px;
}
.star.filled {
  color: #FFD427;
}
.star.half {
  position: relative;
  color: #f3f3f3;
}
.star.half::before {
  content: '★';
  position: absolute;
  left: 0;
  width: 0.3em;
  overflow: hidden;
  color: #FFD427;
}
.rating-score {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  margin-left: 8px;
}

/* 信息卡片 */
.info-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.arrow-icon {
  width: 16px;
  height: 16px;
  transform: rotate(180deg);
}

/* 开关按钮 */
.toggle-switch {
  width: 44px;
  height: 24px;
  background: #e0e0e0;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}
.toggle-switch.active {
  background: #e95758;
}
.toggle-knob {
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: left 0.3s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.toggle-switch.active .toggle-knob {
  left: 22px;
}

/* 支付卡片样式 */
.payment-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 10px 12px;
  border-radius: 12px;
  gap: 12px;
  width: 100%;
  max-width: 240px;
}

.payment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.payment-card-header img {
  height: 20px;
}

.payment-card-order {
  font-size: 13px;
  color: #666;
}

.payment-card-btn {
  background: #ffd2a0;
  color: #000;
  text-align: center;
  padding: 8px 0;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.payment-card-btn:active {
  opacity: 0.8;
}

/* 链接卡片消息样式 */
.link-card-msg {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  max-width: 260px;
}
.link-card-inner {
  padding: 0.75rem;
}
.link-card-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.link-card-btn {
  display: block;
  width: 100%;
  padding: 8px 0;
  text-align: center;
  background: #007aff;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.link-card-btn:active {
  opacity: 0.8;
}

/* 淡入动画 */
.fade-enter-active {
  transition: opacity 0.5s ease-out;
}
.fade-enter-from {
  opacity: 0;
}
</style>
